module.exports = __webpack_public_path__ + "content/1d1a37383d4e4fddbf7e5bcf6413dc09.svg";